// extracted by mini-css-extract-plugin
module.exports = {"cookie_container":"src_cookie_container__MCzpM","cookie_content":"src_cookie_content__1znNj","cookie_button":"src_cookie_button__1nCsg"};